"use strict";
var Observable_1 = require("../../Observable");
var concatMap_1 = require("../../operator/concatMap");
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/concatMap.js
 ** module id = 278
 ** module chunks = 1
 **/